import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  GetAllMerchantStaff(paging, sorting, filtering) {
    return requestGet(apiPath.STORE_STAFF_LIST.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_name: filtering.name,
      f_whatsApp: filtering.whatsApp,
      f_email: filtering.email,
      f_pinCode: filtering.pinCode,
      f_status: filtering.status
    })
  },
  CreateMerchantStaff(payload) {
    return requestPost(apiPath.STORE_STAFF.path, payload)
  },
  UpdateMerchantStaff(id, payload) {
    return requestPut(`${apiPath.STORE_STAFF.path}/${id}`, payload)
  },
  DeleteMerchantStaff(id) {
    return requestDelete(`${apiPath.STORE_STAFF.path}/${id}`)
  },
  CheckPinCode(payload) {
    return requestPost(apiPath.CHECK_PIN_CODE.path, payload)
  }
}

export default api
